import {observer} from "mobx-react";
import React from "react";
import {FormProps, lovValue} from "../../core/form/formUtils";
import ProjectVersionLopProfile from "../domain/project/projectVersionLopProfileDomain";
import {DefinitionType} from "../../core/form/form";
import { MdTextField} from "../../core/components/fields/fields";
import {Validate} from "../../core/form/validate";
import StyledSelect from "../../core/components/fields/styledSelect";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {PROJECT_MATERIAL_ENTITY} from "../entityConstants";
import {createForm} from "../../core/form/createForm";

@observer
class ProjectVersionLopProfilesForm extends React.Component<FormProps<ProjectVersionLopProfile, ProjectVersionLopProfile>, any> {

  render() {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionLopProfilesFormDefinition.formName);
    let {
      type, length, profileDescription, frameMaterial1, frameMaterialMass1, frameMaterial2, frameMaterialMass2,
      frameMaterial3, frameMaterialMass3
    } = fields;
    return (
      <div>
        <div className='row'>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...length.props}/>
            <Validate field={length} value={length.props.value} />
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...type.props} />
            <Validate field={type} value={type.props.value}/>
          </div>
          <div className='fx col-xs-6 col-sm-6'>
            <MdTextField {...profileDescription.props} />
            <Validate field={profileDescription} value={profileDescription.props.value}/>
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-3 col-sm-3'>
            <StyledSelect {...frameMaterial1.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})} />
            <Validate field={frameMaterial1} value={frameMaterial1.props.value}/>
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...frameMaterialMass1.props} />
            <Validate field={frameMaterialMass1} value={frameMaterialMass1.props.value}/>
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <StyledSelect {...frameMaterial2.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})} />
            <Validate field={frameMaterial2} value={frameMaterial2.props.value}/>
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...frameMaterialMass2.props} />
            <Validate field={frameMaterialMass2} value={frameMaterialMass2.props.value}/>
          </div>
        </div>
        <div className='row'>
          <div className='fx col-xs-3 col-sm-3'>
            <StyledSelect {...frameMaterial3.props} async asterixForAll clearable loadOptions={optionsSearch.bind(this, PROJECT_MATERIAL_ENTITY, {projectVersionId : lovValue(dataObject.projectVersion)})} />
            <Validate field={frameMaterial3} value={frameMaterial3.props.value}/>
          </div>
          <div className='fx col-xs-3 col-sm-3'>
            <MdTextField {...frameMaterialMass3.props} />
            <Validate field={frameMaterialMass3} value={frameMaterialMass3.props.value}/>
          </div>
        </div>
      </div>
    );
  }
}


export const ProjectVersionLopProfilesFormDefinition: DefinitionType = {
  formName: 'ProjectVersionLopProfilesForm',
  fields: [
    {name : 'type', validators: ['IsRequired']},
    {name : 'length', validators: ['IsRequired', 'IsNumber']},
    {name : 'profileDescription', validators: ['IsRequired']},
    {name : 'frameMaterial1', validators: ['IsRequired']},
    {name : 'frameMaterialMass1', validators: ['IsNumber']},
    {name : 'frameMaterial2'},
    {name : 'frameMaterialMass2', validators: ['IsNumber']},
    {name : 'frameMaterial3'},
    {name : 'frameMaterialMass3', validators: ['IsNumber']},
  ]
};

export default createForm(ProjectVersionLopProfilesFormDefinition, null)(ProjectVersionLopProfilesForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionLopProfilesForm.tsx